import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("VideoWidget", {
  attributes: {
    video: {
      title: "Video",
      description:
        "Select a video to embed. It should be in a web-compatible format like MP4 with h264 for video and mp3 for audio.",
    },
    captionTrack: {
      title: "Caption track",
      description:
        "Select a caption track for the video. It should be in WebVTT format.",
    },
    descriptionTrack: {
      title: "Description track",
      description:
        "Select a description track for the video. It should be in WebVTT format.",
    },
    poster: {
      title: "Poster image",
      description: "Select an image to show before the video is played.",
    },
    ariaLabel: {
      title: "Aria label",
      description:
        "Provide an aria label for the video, describing its content and purpose. This is important for accessibility, especially for users relying on screen readers.",
    },
  },

  properties: ["video", "poster"],

  propertiesGroups: [
    {
      title: "Accessability",
      properties: ["captionTrack", "descriptionTrack", "ariaLabel"],
    },
    {
      title: "Controls",
      properties: ["autoplay", "loop", "muted"],
    },
  ],

  validations: [
    [
      "video",
      (video) => {
        if (!video) return "A video has to be selected";
        const mimeType = video.get("blob").raw().metadata().get("contentType");

        if (mimeType !== "video/mp4") {
          return `The video is not from type video/mp4. It is a ${mimeType}.`;
        }
      },
    ],
    [
      "captionTrack",
      (track) => {
        if (!track) return; // optional
        if (!track.obj()?.url()) return "Caption track has no URL";
      },
    ],
    [
      "descriptionTrack",
      (track) => {
        if (!track) return;
        if (!track.obj()?.url()) return "Description track has no URL";
      },
    ],
    [
      "ariaLabel",
      (label) => {
        if (!label) {
          return {
            message:
              "It is recommended to provide an aria-label for accessibility.",
            severity: "warning",
          };
        }
      },
    ],
  ],
});
